import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Avatar,
} from '@mui/material';
import { getAllDrivers } from '../../../services/api'; // Make sure this API call exists

const AllDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDrivers();
  }, []);

  const fetchDrivers = async () => {
    try {
      const response = await getAllDrivers();
      setDrivers(response.data.data || []);
    } catch (error) {
      console.error('Error fetching drivers:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
    
      {drivers.length === 0 ? (
        <Typography>No drivers found.</Typography>
      ) : (
        <Grid container spacing={2}>
          {drivers.map((driver, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar
                      src={driver.userPhotoUrl}
                      alt={driver.name}
                      sx={{ width: 56, height: 56, mr: 2 }}
                    />
                    <Typography variant="h6">{driver.name}</Typography>
                  </Box>
                  <Typography><strong>Contact:</strong> {driver.contactNumber}</Typography>
                  <Typography><strong>Email:</strong> {driver.email}</Typography>
                  <Typography><strong>License No.:</strong> {driver.licenseNumber}</Typography>
                  <Typography><strong>Vehicle No.:</strong> {driver.vehicleNumber}</Typography>
                  <Typography><strong>RC:</strong> <a href={driver.rcImageUrl} target="_blank" rel="noopener noreferrer">View</a></Typography>
                  <Typography><strong>Aadhar:</strong> <a href={driver.aadharCardUrl} target="_blank" rel="noopener noreferrer">View</a></Typography>
                  <Typography><strong>License:</strong> <a href={driver.licenseImageUrl} target="_blank" rel="noopener noreferrer">View</a></Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default AllDrivers;